import {
    newQuickJSWASMModuleFromVariant,
    newVariant,
    RELEASE_SYNC,
    QuickJSWASMModule,
    type QuickJSContext,
} from 'quickjs-emscripten'
import wasmLocation from '@jitl/quickjs-wasmfile-release-sync/wasm?url'
import { ref } from 'vue'
import useWidgetViewManager from '../widget-view-manager'
import { useI18n } from '../i18n'
import { captureException } from '@sentry/vue'

const isTest = import.meta.env.MODE === 'test'
const module = ref<Promise<QuickJSWASMModule>>()

export default function useQuickJsContext() {
    return async (): Promise<QuickJSContext | undefined> => {
        const { t } = useI18n()
        const { showError } = useWidgetViewManager()

        try {
            if (!module.value) {
                const variant = newVariant(RELEASE_SYNC, {
                    wasmLocation: isTest ? undefined : wasmLocation,
                })
                module.value = newQuickJSWASMModuleFromVariant(variant) // no await on purpose, to store Promise
            }

            const wasmModule = await module.value!
            return wasmModule.newContext()
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error: any) {
            showError({
                title: (error?.message || error)?.includes('Refused to create a WebAssembly object because \'unsafe-eval\'') ?
                    t('views.widget.error.browser_outdated') : t('views.widget.error.title'),
                description: t('views.widget.error.quick_js_error'),
                error,
            })

            captureException(error)
            // eslint-disable-next-line no-console
            console.error(error)
        }
    }
}
